import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const propTypes = {
  imageUrl:        PropTypes.string.isRequired,
  headline:        PropTypes.string.isRequired,
  subhead:         PropTypes.string.isRequired,
  listHeader:      PropTypes.string.isRequired,
  listClassName:   PropTypes.string,
  listItems:       PropTypes.array.isRequired,
  icon:            PropTypes.string,
  actionLabel:     PropTypes.string,
  cardClassName:   PropTypes.string,
  buttonClassName: PropTypes.string,
  onActionClick:   PropTypes.func,
  dataTestId:      PropTypes.string.isRequired,
};

const ListWithAction = ({ imageUrl, headline, subhead, listHeader, listClassName, listItems, icon, actionLabel, cardClassName,
  buttonClassName, onActionClick, dataTestId }) => {

  const list = () => {
    return listItems.map(item => {
      return (
        <li className={`_displayFlex ${listClassName}`}>
          <i className='materialIcon -primary --xxsmall'>{icon}</i>
          <span className='byline _inline -darkBlue _fontSize--small'>
            {item}
          </span>
        </li>
      );
    });
  }

  const getButtonClassName = () => classNames('ds-btn -primary --block', buttonClassName)
  const getCardClassName   = () => classNames('cardSection', '_textAlign_center', cardClassName);

  const renderActionBtn = () => {
    if(onActionClick && actionLabel){
      return <button className={getButtonClassName()} data-testid={dataTestId} onClick={onActionClick}>{actionLabel}</button>
    }
  }

  return (
    <section className={getCardClassName()}>
      <div>
        <img src={imageUrl} className='_marginBottom--small' alt='invoice' />
        <strong className="copy -darkBlue _displayBlock">{headline}</strong>
        <small className="byline _fontSize--small _marginBottom--small">{subhead}</small>
        <small className="byline _fontSize--small _marginBottom--xxsmall">{listHeader}</small>
        <div className='_displayFlex _justifyContent-center _marginBottom--small'>
          <ul className='_alignInitial'>{list()}</ul>
        </div>
      </div>
      { renderActionBtn() }
    </section>
  );
}

ListWithAction.propTypes = propTypes;
export default ListWithAction;



// WEBPACK FOOTER //
// ./src/features/PrincipalPaydown/components/ListWithAction.js